import { toast } from 'react-toastify';
import { Auth } from 'aws-amplify';

import history from '../../services/history';

export function signIn(username, password) {
  return async dispatch => {
    try {
      dispatch(signInRequest());

      const user = await Auth.signIn(username, password);

      let accessLevel;

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        dispatch(completePasswordSuccess(user));
        dispatch(passwordChallengeRequest());
        history.push('/cambiar-clave');
      } else {
        const group = user.signInUserSession.idToken.payload['cognito:groups'][0];

        const group_full_admin = process.env.REACT_APP_GROUP_FULL_ADMIN;
        const group_admin = process.env.REACT_APP_GROUP_ADMIN;
        const group_operator = process.env.REACT_APP_GROUP_OPERATORS;

        if (group === group_operator) {
          accessLevel = 1;
        } else if (group === group_admin) {
          accessLevel = 2;
        } else if (group === group_full_admin) {
          accessLevel = 3;
        }

        dispatch(signInSuccess(user.username, accessLevel));
        history.push('/patentes');
      }
    } catch (err) {
      toast.error('Usuario o contraseña incorrectos');
      dispatch(signFailure());
    }
  };
}

export function completePassword(newPassword) {
  return async (dispatch, getState) => {
    try {
      dispatch(signInRequest());

      const { user } = getState();

      const signedUser = await Auth.completeNewPassword(user.user, newPassword);

      let accessLevel;

      const group = signedUser.signInUserSession.idToken.payload['cognito:groups'][0];

      const group_full_admin = process.env.REACT_APP_GROUP_FULL_ADMIN;
      const group_admin = process.env.REACT_APP_GROUP_ADMIN;
      const group_operator = process.env.REACT_APP_GROUP_OPERATORS;

      if (group === group_operator) {
        accessLevel = 1;
      } else if (group === group_admin) {
        accessLevel = 2;
      } else if (group === group_full_admin) {
        accessLevel = 3;
      }

      dispatch(signInSuccess(signedUser.username, accessLevel));
      history.push('/patentes');
    } catch (err) {
      toast.error(
        'Error al cambiar la contraseña. Por favor intente nuevamente.'
      );
      dispatch(signFailure());
    }
  };
}

export function forgotPassword(username) {
  return async dispatch => {
    try {
      dispatch(forgotPasswordRequest());

      const data = await Auth.forgotPassword(username);

      dispatch(forgotPasswordSuccess());

      toast.success(
        `Se ha enviado un correo electrónico a ${data.CodeDeliveryDetails.Destination}`
      );
      history.push('/cambiar-contrasena-perdida');
    } catch (err) {
      if (err.code === 'UserNotFoundException') {
        toast.error('Usuario no encontrado.');
      } else {
        toast.error('Hubo un error. Por favor intente nuevamente.');
      }
      dispatch(signFailure());
    }
  };
}

export function forgotPasswordSubmit(username, code, newPassword) {
  return async dispatch => {
    try {
      dispatch(forgotPasswordRequest());

      await Auth.forgotPasswordSubmit(username, code, newPassword);

      dispatch(forgotPasswordSuccess());

      toast.success('Contraseña modificada con éxito');
      history.push('/');
    } catch (err) {
      if (err.code === 'CodeMismatchException') {
        toast.error('¡El código proporcionado no es válido!');
      } else if (err.code === 'ExpiredCodeException') {
        toast.error('¡El código provisto ha expirado!');
      } else {
        toast.error('Hubo un error. Por favor intente nuevamente.');
      }

      dispatch(signFailure());
    }
  };
}

export function signInRequest() {
  return {
    type: '@auth/SIGN_IN_REQUEST'
  };
}

export function signInSuccess(username, accessLevel) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { username, accessLevel }
  };
}

export function passwordChallengeRequest() {
  return {
    type: '@auth/PASSWORD_CHALLENGE_REQUEST'
  };
}

export function forgotPasswordRequest() {
  return {
    type: '@auth/FORGOT_PASSWORD_REQUEST'
  };
}

export function forgotPasswordSuccess() {
  return {
    type: '@auth/FORGOT_PASSWORD_SUCCESS'
  };
}

export function completePasswordRequest() {
  return {
    type: '@auth/COMPLETE_PASSWORD_REQUEST'
  };
}

export function completePasswordSuccess(user) {
  return {
    type: '@auth/COMPLETE_PASSWORD_SUCCESS',
    payload: { user }
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE'
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT'
  };
}
